import React from 'react';
import { Mail } from 'lucide-react';
import UnlayerDemo from './UnlayerDemo';
import './EmailEditorComparison.css';

/**
 * Email Editor
 * Unlayer email builder
 */
const EmailEditorComparison = () => {
  return (
    <div className="editor-comparison-container">
      {/* Header */}
      <div className="editor-comparison-header">
        <div className="header-content">
          <div className="header-icon">
            <Mail size={28} color="#3D9AD1" />
          </div>
          <div>
            <h1 className="header-title">Email Editor</h1>
            <p className="header-subtitle">
              Design beautiful email templates with drag & drop
            </p>
          </div>
        </div>
      </div>

      {/* Editor Display */}
      <div className="editor-display">
        <UnlayerDemo />
      </div>
    </div>
  );
};

export default EmailEditorComparison;
